<template>
  <div v-ps class="project-overview">
    <div class="wrap">
      <main>
        <basic-info v-loading="loading" :project-info="projectInfo" class="box"></basic-info>
        <project-log :project-id="projectInfo.id" class="box"></project-log>
      </main>
      <aside>
        <project-info v-loading="loading" :project-info="projectInfo" class="box"></project-info>
        <project-member :project-id="$route.params.projectId" class="box"></project-member>
      </aside>
    </div>
  </div>
</template>

<script>
import BasicInfo from "./BasicInfo"
import ProjectInfo from "./ProjectInfo"
import ProjectLog from "./ProjectLog"
import ProjectMember from "./ProjectMember"
import { getProject } from "@/api/project/project"

export default {
  name: "project-overview",
  components: {
    BasicInfo,
    ProjectInfo,
    ProjectLog,
    ProjectMember
  },
  data() {
    return {
      loading: false,
      projectInfo: {}
    }
  },
  methods: {
    init() {
      this.loading = true
      getProject(this.$route.params.projectId).then(res => {
        res.startPeriod = res.startPeriod.slice(0, 10)
        res.endPeriod = res.endPeriod.slice(0, 10)
        this.projectInfo = res
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.project-overview {
  height: 100%;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding: 32px 0;
  font-size: $font-size-main;
  .wrap {
    display: flex;
    min-width: 1114px;
    justify-content: center;
  }
  main {
    width: 720px;
    margin-right: 18px;
  }
  aside {
    width: 376px;
  }
  .box {
    background-color: #fff;
    padding: 13px 40px 28px 32px;
    margin-bottom: 18px;
  }
  ::v-deep {
    .topic-title {
      position: relative;
      margin-bottom: 16px;
      color: $color-font-first;
      font-size: $font-size-title-topic;
      line-height: 28px;
      &::before {
        content: "";
        position: absolute;
        left: -16px;
        width: 6px;
        height: 28px;
        border-radius: 4px;
        background-color: $color-main;
      }
    }
    .info-row:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
